import { z } from "zod"

export const DartyOctopusSessionSchema = z.object({
    affiliateCode: z.string(),
    accessToken: z.string(),
    user: z.object({
        fullname: z.string(),
    }),
})
